import { sqliteTable, text, integer, real, index } from "drizzle-orm/sqlite-core";

// ============================================================================
// attendance — บันทึกเวลา (Attendance)
// ============================================================================
export const attendance = sqliteTable("hr_attendance", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull(),
  employeeId: text("employee_id").notNull(),
  date: text("date"), // YYYY-MM-DD (optional, derived from checkInDatetime for backward compat)
  checkInDatetime: text("check_in_datetime"), // ISO datetime e.g. "2025-01-15T08:30"
  checkOutDatetime: text("check_out_datetime"), // ISO datetime e.g. "2025-01-15T17:30"
  workingHours: real("working_hours").notNull().default(0),
  status: text("status").notNull().default("present"), // present, absent, half_day, on_leave
  overtimeHours: real("overtime_hours").notNull().default(0),
  lateMinutes: integer("late_minutes").notNull().default(0),
  remarks: text("remarks"),
  // Audit columns
  createdBy: text("created_by"),
  createdAt: text("created_at").notNull(),
  updatedBy: text("updated_by"),
  updatedAt: text("updated_at").notNull(),
  deletedBy: text("deleted_by"),
  deletedAt: text("deleted_at"),
}, (table) => ({
  att_company_date_idx: index("att_company_date_idx").on(table.companyId, table.date),
  att_employee_idx: index("att_employee_idx").on(table.companyId, table.employeeId, table.date),
}));

// Type exports
export type Attendance = typeof attendance.$inferSelect;
export type NewAttendance = typeof attendance.$inferInsert;
